<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('form_label_search') || '客户/品牌/品类/编号 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <slot />
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-drawer
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      show-close
      :visible.sync="advqueryDialogVisible"
      size="600px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="ml-4 mr-4">
        <el-form
          ref="form"
          :model="form"
          label-width="100px"
          label-position="right"
          size="mini"
        >
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_combineStatus') || '产品状态'"
              >
                <el-checkbox-group v-model="form.evgCombineStatusList">
                  <el-checkbox label="Q">
                    {{ $l('form_label_status_Q') || '企划' }}
                  </el-checkbox>
                  <el-checkbox label="Y">
                    {{ $l('form_label_status_Y') || '正式' }}
                  </el-checkbox>
                  <el-checkbox label="D">
                    {{ $l('form_label_status_D') || '已删除' }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_evgCombineNo') || '组合产品编号'"
              >
                <el-input
                  v-model.trim="form.evgCombineNo"
                  :placeholder="
                    $l('tip_input_evgCombineNo') || '请填写组合产品编号'
                  "
                  clearable
                  size="mini"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$l('form_label_combineName') || '中文名称'">
                <el-input
                  v-model.trim="form.combineName"
                  :placeholder="
                    $l('tips_input_combineName_placeholder') || '请填写中文名称'
                  "
                  clearable
                  size="mini"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_combineNameEn') || '英文名称'"
              >
                <el-input
                  v-model.trim="form.combineNameEn"
                  :placeholder="
                    $l('tips_input_combineNameEn_placeholder') ||
                      '请填写英文名称'
                  "
                  clearable
                  size="mini"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$l('form_label_cust') || '客户'">
                <dict-select
                  v-model="form.listCustCode"
                  url="/ecom/ecom/evg/spu/customerFormalSelect"
                  :placeholder="
                    $l('tips_select_cust_placeholder') || '请选择客户'
                  "
                  filterable
                  clearable
                  multiple
                  size="mini"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_brand') || '品牌'"
                prop="brandCode"
              >
                <dict-select
                  v-model="form.listBrandCode"
                  url="/master/common/dict/brandSelect"
                  :placeholder="$l('tips_select_brand_data') || '请选择品牌'"
                  :selectedLabel.sync="form.brandName"
                  clearable
                  filterable
                  multiple
                  size="mini"
                  style="width:100%"
                ></dict-select>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_category') || '品类'"
                prop="categoryCode"
              >
                <el-cascader
                  :options="categoryTree"
                  :props="{
                    emitPath: false,
                    checkStrictly: false,
                    value: 'value',
                    label: 'label',
                  }"
                  ref="cascaderCategoryTreeRef"
                  v-model="form.categoryCode"
                  filterable
                  clearable
                  style="width: 100%"
                  :showAllLevels="false"
                  :placeholder="$l('tips_select_category') || '请选择品类'"
                >
                  <template slot-scope="{ node, data }">
                    <span>{{ data.label }}</span>
                    <span v-if="!node.isLeaf">
                      ({{ data.children.length }})
                    </span>
                  </template>
                </el-cascader>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-row :gutter="10">
                <el-form-item
                  :label="$l('form_label_advquery_createDate') || '创建时间'"
                >
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.createDateStart"
                      type="date"
                      value-format="yyyy-MM-dd"
                      :placeholder="
                        $l('tip_please_select_createDate') || '请选择创建时间'
                      "
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.createDateEnd"
                      type="date"
                      value-format="yyyy-MM-dd"
                      :placeholder="
                        $l('tip_please_select_createDate') || '请选择创建时间'
                      "
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
            <el-col :span="24">
              <el-row :gutter="10">
                <el-form-item
                  :label="$l('form_label_advquery_modifyDate') || '修改时间'"
                >
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.modifyDateStart"
                      type="date"
                      value-format="yyyy-MM-dd"
                      :placeholder="
                        $l('tip_please_select_modifyDate') || '请选择修改时间'
                      "
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.modifyDateEnd"
                      type="date"
                      value-format="yyyy-MM-dd"
                      :placeholder="
                        $l('tip_please_select_modifyDate') || '请选择修改时间'
                      "
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_creator') || '创建人'"
                prop="listCreateBy"
              >
                <dict-select
                  v-model="form.listCreateBy"
                  url="/master/common/dict/baseUserSelect"
                  :placeholder="$l('tip_select_creator') || '请选择创建人'"
                  clearable
                  filterable
                  multiple
                  size="mini"
                  style="width:100%"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$l('form_label_modified') || '修改人'">
                <dict-select
                  v-model="form.listModifyBy"
                  url="/master/common/dict/baseUserSelect"
                  :placeholder="$l('tip_select_modified') || '请选择修改人'"
                  clearable
                  filterable
                  multiple
                  size="mini"
                  style="width:100%"
                ></dict-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="dialog-footer mb-4 mt-2 d-flex  justify-content-end">
          <el-button size="mini" @click="closeAdvqueryDialog">{{
            $l('INDEX.btn_cancel_query') || '取消查询'
          }}</el-button>
          <el-button size="mini" type="warning" @click="reset">{{
            $l('INDEX.btn_reset_filter') || '重置条件'
          }}</el-button>
          <el-button size="mini" type="primary" @click="advquery">{{
            $l('INDEX.btn_data_retrieval') || '数据检索'
          }}</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  evgCombineStatusList: ['Q', 'Y'],
}
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      masterCategoryParams: { parentCode: 'ABSHome' },
      categoryTree: [],
    }
  },

  mounted() {
    this.query()
    this.getTreeData()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    getTreeData() {
      this.$api
        .ecomAmzSpuCategoryApi(this.masterCategoryParams)
        .then((res) => {
          this.categoryTree = res.body.data || []
        })
        .catch(() => {})
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
